import * as React from 'react';

// ─── Types ────────────────────────────────────────────────────────────────────

/** A single label/value pair rendered by `StepperAccordionSummary`. */
export interface StepperAccordionSummaryItem {
  label: string;
  value: string;
}

export interface StepperAccordionSummaryProps {
  /** Ordered label/value pairs — rendered as "Label: Value". */
  items: StepperAccordionSummaryItem[];
}

// ─── Component ────────────────────────────────────────────────────────────────

/**
 * Key/value recap row shown under a closed, completed `StepperAccordion` section header —
 * reflects live form values rather than a static placeholder string.
 */
export function StepperAccordionSummary({ items }: StepperAccordionSummaryProps): React.JSX.Element {
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-1">
      {items.map((item) => (
        // `truncate` has no effect on an inline <span> (text-overflow needs a block-level box with
        // a bounded width) — each item is its own flex container so the value can shrink and ellipsize.
        <div key={item.label} className="flex min-w-0 max-w-full items-baseline gap-1">
          <span className="shrink-0 text-sm font-medium text-foreground/60 tracking-wide">{item.label}:</span>
          <span className="min-w-0 truncate text-foreground">{item.value}</span>
        </div>
      ))}
    </div>
  );
}
